import React from 'react';
import './index.scss';
import logo from '../../images/logo-loading.png';
import LogoText from '../LogoText';

export default function loading({ progress }) {
  return (
    <div className="loading-root">
      <div className="loading-header">
        <img className="loading-logo" src={logo} alt="" />
        <div className="progress-box">
          <div className="progress-inner" style={{width: progress + '%'}}></div>
        </div>
      </div>
      <div className="loading-footer">
        <div className="tips-box">
          <div className="left">
            <i className="icon-font">&#xe610;</i>
            <p>单指移动屏幕</p>
          </div>
          <div className="right">
            <i className="icon-font">&#xe611;</i>
            <p>双指缩放屏幕</p>
          </div>
        </div>
        <LogoText />
      </div>
    </div>
  )
}